export default __webpack_public_path__ + "static/media/12.a3a5b0c0.png";